var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Checkbox",
        {
          staticClass: "checkboxComponent",
          attrs: { disabled: false, "checkbox-id": "changeLoginPeriod" },
          model: {
            value: _vm.handleValue,
            callback: function ($$v) {
              _vm.handleValue = $$v
            },
            expression: "handleValue",
          },
        },
        [
          _c("span", { staticClass: "label" }, [
            _vm._v("ログインしたままにする"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v("共有のパソコンやタブレットではチェックを外してください。"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }